<template>
  <div>
    <Head-Title></Head-Title>
    <Head-Tips></Head-Tips>
  </div>
</template>
<script>
import HeadTitle from './Head-Title.vue';
import HeadTips from './Head-Tips.vue';

export default {
  components: {
    HeadTitle,
    HeadTips,
  },
}
</script>
<style scoped></style>
